import React, { useState } from 'react';

import { BsPlusLg } from 'react-icons/bs';
import { UiComponent } from 'components';
import Modal from '../Modal';
import { PartnerQuery } from 'queries';
import { IPartner } from 'types';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const { mutateAsync } = PartnerQuery.useCeate();

  const handleCreate = async (data: IPartner) => {
    try {
      await mutateAsync(data);
      setIsOpen(false);
      toast.success('파트너가 추가되었습니다.');
    } catch {
      toast.error(DEFAULT_ERROR_MESSAGE);
    }
  };

  return (
    <>
      <div
        css={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 12,
          margin: '12px 0 20px',
          '> h3': { margin: 0 },
        }}
      >
        <UiComponent.PageTitle>파트너</UiComponent.PageTitle>
        <UiComponent.Button
          variant="contained"
          color="primary"
          onClick={() => setIsOpen(true)}
          css={{ height: '40px' }}
        >
          <BsPlusLg size={15} />
          파트너 추가
        </UiComponent.Button>
      </div>
      {isOpen && (
        <Modal onClose={() => setIsOpen(false)} onSave={handleCreate} />
      )}
    </>
  );
}

export default Header;
